 
import ScrollToTop from "react-scroll-to-top";
import { Link } from 'react-router-dom';

export default function Categoryslides() {
  return (
  <>

  <div className="p-2	top-1 flex items-stretch overflow-x-auto space-x-1 w-/2 bg-black	text-slate-200  ">

  <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
  <Link to="#"
  className="mt-2 inline-flex items-center gap-2 rounded border border-indigo-600 bg-indigo-900 px-2 py-2 text-white hover:bg-transparent hover:text-indigo-600 focus:outline-none focus:ring active:text-indigo-500" 
><span><img src="./assets/icons/catalog.png" className="h-8 w-8 
    rounded --300" alt=""/></span>
  <span className="text-sm font-medium"> All    </span>

  <svg
    className="h-5 w-5 rtl:rotate-180"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
    
  </svg>
</Link>
    
  <span className="text-white p-1 inline-block align-baseline">   </span>

  </section>
 

  <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
  <Link to="/Construction" 
     className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
   >
    <span><img src="./assets/icons/building.png" className="h-8 w-8 
       rounded --300" alt=""/></span>
     <span className="text-sm font-medium"> Construction    </span>
   
     <svg
       className="h-5 w-5 rtl:rotate-180"
       xmlns="http://www.w3.org/2000/svg"
       fill="none"
       viewBox="0 0 24 24"
       stroke="currentColor"
     >
      <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
     </svg>
 
   </Link>
       
     <span className="text-white p-1 inline-block align-baseline">   </span>
   
     </section>

 

     <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
    <Link to="/Makeup" 
       className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
     ><span><img src="./assets/icons/makeup.png" className="h-8 w-8 
         rounded --300" alt=""/></span>
       <span className="text-sm font-medium"> Beauty websites    </span>
     
       <svg
         className="h-5 w-5 rtl:rotate-180"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor"
       >
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
       </svg>
     </Link>
         
       <span className="text-white p-1 inline-block align-baseline">   </span>
     
       </section>



       <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
    <Link to="/Businessconsulting" 
       className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
     ><span><img src="https://ik.imagekit.io/sitekitpro/assets/icons/cooperation.png" className="h-8 w-8 
         rounded --300" alt=""/></span>
       <span className="text-sm font-medium"> Business & Consulting  </span>
     
       <svg
         className="h-5 w-5 rtl:rotate-180"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor"
       >
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
       </svg>
     </Link>
         
       <span className="text-white p-1 inline-block align-baseline">   </span>
     
       </section>


       <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
    <Link to="/Clothingstore" 
       className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
     ><span><img src="https://ik.imagekit.io/sitekitpro/assets/icons/brand.png?updatedAt=1744058150726" className="h-8 w-8 
         rounded --300" alt=""/></span>
       <span className="text-sm font-medium"> Clothing Store </span>
     
       <svg
         className="h-5 w-5 rtl:rotate-180"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor"
       >
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
       </svg>
     </Link>
         
       <span className="text-white p-1 inline-block align-baseline">   </span>
     
       </section>
 

       <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
    <Link to="/Digitalmarketing" 
       className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
     ><span><img src="https://ik.imagekit.io/sitekitpro/assets/icons/marketing.png" className="h-8 w-8 
         rounded --300" alt=""/></span>
       <span className="text-sm font-medium"> Digital Marketing</span>
     
       <svg
         className="h-5 w-5 rtl:rotate-180"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor"
       >
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
       </svg>
     </Link>
         
       <span className="text-white p-1 inline-block align-baseline">   </span>
     
       </section>


       <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
    <Link to="/Blogmagazine" 
       className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
     ><span><img src="https://ik.imagekit.io/sitekitpro/assets/icons/newspaper.png?updatedAt=1744058655605" className="h-8 w-8 
         rounded --300" alt=""/></span>
       <span className="text-sm font-medium"> Blog Magazine </span>
     
       <svg
         className="h-5 w-5 rtl:rotate-180"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor"
       >
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
       </svg>
     </Link>
         
       <span className="text-white p-1 inline-block align-baseline">   </span>
     
       </section>


       <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
    <Link to="/Agriculture" 
       className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
     ><span><img src="https://ik.imagekit.io/sitekitpro/assets/icons/sprout.png" className="h-8 w-8 
         rounded --300" alt=""/></span>
       <span className="text-sm font-medium"> Agriculture </span>
     
       <svg
         className="h-5 w-5 rtl:rotate-180"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor"
       >
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
       </svg>
     </Link>
         
       <span className="text-white p-1 inline-block align-baseline">   </span>
     
       </section>


       <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
    <Link to="/Hotelandresort" 
       className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
     ><span><img src="https://ik.imagekit.io/sitekitpro/assets/icons/building.png" className="h-8 w-8 
         rounded --300" alt=""/></span>
       <span className="text-sm font-medium"> Hotel & Resort </span>
     
       <svg
         className="h-5 w-5 rtl:rotate-180"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor"
       >
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
       </svg>
     </Link>
         
       <span className="text-white p-1 inline-block align-baseline">   </span>
     
       </section>


       <section className="text-center flex-shrink-0 rounded p-1 border-0 border-indigo-300 text-slate-200">
    
    <Link to="/Otherssites" 
       className="mt-2 inline-flex items-center gap-1 rounded border border-indigo-600 bg-white px-2 py-2 text-orange-800 hover:bg-transparent hover:text-white focus:outline-none focus:ring active:text-indigo-500" 
     ><span><img src="https://ik.imagekit.io/sitekitpro/assets/icons/priority-list.png" className="h-8 w-8 
         rounded --300" alt=""/></span>
       <span className="text-sm font-medium"> Others Premium Sites </span>
     
       <svg
         className="h-5 w-5 rtl:rotate-180"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke="currentColor"
       >
          <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
       </svg>
     </Link>
         
       <span className="text-white p-1 inline-block align-baseline">   </span>
     
       </section>


</div>

<div/>
      <ScrollToTop smooth />
  </>
  )
}
 